import React, { useEffect, useState } from 'react';
import AuthContainer from '../../../component/Public/Auth/AuthContainer/AuthContainer';
import SignUpSection from '../../../component/Public/Auth/SignUpSection/SignUpSection';
import { useIntl } from 'react-intl';
import { translate } from '../../../utility/messageTranslator/translate';
import AuthAboutSection from '../../../component/Public/Auth/AuthAboutSection/AuthAboutSection';
import { StoreState } from '../../../config/StoreProvider/StoreProvider';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
// eslint-disable-next-line max-len
import { setShowCertificateTemplateHasEditedNotSentCertificatesModal } from '../../../store/certificate-template/actions';
import { connect } from 'react-redux';

export enum SignUpSectionType {
  // eslint-disable-next-line no-unused-vars
  LOGIN = 'LOGIN',
  // eslint-disable-next-line no-unused-vars
  REGISTER = 'REGISTER',
}

export enum AuthEntryType {
  // eslint-disable-next-line no-unused-vars
  ADMIN = 'ADMIN',
  // eslint-disable-next-line no-unused-vars
  ORGANISER = 'ORGANISER',
  // eslint-disable-next-line no-unused-vars
  USER = 'USER',
}

export type AboutProcerty = {
  title: string;
  label1: string;
  label2: string;
  label3: string;
};

type Props = {
  sectionType?: SignUpSectionType;
  showCertificateTemplateHasEditedNotSentCertificatesModal: boolean;
  onSetShowCertificateTemplateHasEditedNotSentCertificatesModal: (
    show: boolean,
  ) => void;
  authEntry?: AuthEntryType;
};

const SignUpPage = ({
  sectionType,
  showCertificateTemplateHasEditedNotSentCertificatesModal,
  onSetShowCertificateTemplateHasEditedNotSentCertificatesModal,
  authEntry,
}: Props) => {
  const intl = useIntl();
  const [section, setSection] = useState(
    sectionType ? sectionType : SignUpSectionType.LOGIN,
  );

  const registrationTranslations: AboutProcerty = {
    title: translate(intl, 'LEFT_SECTION_REGISTRATION.TITLE'),
    label1: translate(intl, 'LEFT_SECTION_REGISTRATION.LABEL_1'),
    label2: translate(intl, 'LEFT_SECTION_REGISTRATION.LABEL_2'),
    label3: translate(intl, 'LEFT_SECTION_REGISTRATION.LABEL_3'),
  };

  const loginTranslations: AboutProcerty = {
    title: translate(intl, 'LEFT_SECTION_LOGIN.TITLE'),
    label1: translate(intl, 'LEFT_SECTION_LOGIN.LABEL_1'),
    label2: translate(intl, 'LEFT_SECTION_LOGIN.LABEL_2'),
    label3: translate(intl, 'LEFT_SECTION_LOGIN.LABEL_3'),
  };

  useEffect(() => {
    if (!showCertificateTemplateHasEditedNotSentCertificatesModal) {
      onSetShowCertificateTemplateHasEditedNotSentCertificatesModal(true);
    }
  }, [showCertificateTemplateHasEditedNotSentCertificatesModal]);

  const getTitle = () => {
    if (
      section === SignUpSectionType.REGISTER &&
      authEntry === AuthEntryType.ORGANISER
    ) {
      return translate(intl, 'SIGN_UP_PAGE.ORGANISER_REGISTRATION');
    }

    if (section === SignUpSectionType.REGISTER) {
      return translate(intl, 'SIGN_UP_PAGE.REGISTRATION_TITLE_MAIN');
    }

    return translate(intl, 'SIGN_UP_PAGE.TITLE_MAIN');
  };

  const getSection = () => {
    if (section === SignUpSectionType.REGISTER) {
      return <AuthAboutSection translations={registrationTranslations} />;
    }

    return <AuthAboutSection translations={loginTranslations} />;
  };

  return (
    <AuthContainer
      title={getTitle()}
      onChangeSection={setSection}
      section={section}
      leftSection={getSection()}
      authEntry={authEntry}
    >
      <SignUpSection
        section={section}
        onChangeSection={setSection}
        authEntry={authEntry}
      />
    </AuthContainer>
  );
};

const mapStateToProps = (state: StoreState) => ({
  showCertificateTemplateHasEditedNotSentCertificatesModal:
    state.certificateTemplate
      .showCertificateTemplateHasEditedNotSentCertificatesModal,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  onSetShowCertificateTemplateHasEditedNotSentCertificatesModal: (
    show: boolean,
  ) =>
    dispatch(setShowCertificateTemplateHasEditedNotSentCertificatesModal(show)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUpPage);
